export default theme => ({
  chip__enabled: {
    color: theme.palette.success.dark,
    border: `1px solid ${theme.palette.success.dark}`,
  },
  chip__disabled: {
    color: theme.palette.userSecondary.dark,
    border: `1px solid ${theme.palette.userSecondary.dark}`,
    margin: 10,
  },
  title: {
    fontSize: theme.textSizes[5],
    fontWeight: 500,
    marginBottom: theme.sizes[1],
  },
  subtitle: {
    display: "inline-block",
    textTransform: "uppercase",
    fontSize: theme.textSizes[0],
    fontWeight: 500,
    marginBottom: theme.sizes[4],
    color: theme.palette.disabled.main,
    marginTop: 10,
  },
  text: {
    fontSize: theme.textSizes[2],
    marginBottom: theme.sizes[1],
  },
  status: {
    color: theme.palette.secondary.dark,
    border: `1px solid ${theme.palette.secondary.dark}`,
    float: "right",
  },
  degradated: {
    color: theme.palette.primary.dark,
    border: `1px solid ${theme.palette.primary.dark}`,
    float: "right",
  },
  column: {
    textAlign: "center",
  },
  dataCard: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    "@media (max-width: 400px)": {
      marginBottom: 10,
    },
    marginRight: 15,
    padding: `${theme.spacing(1)}px`,
    "& div": {
      minWidth: "100%",
    },
  },
  divider: {
    marginTop: theme.sizes[4],
    marginBottom: theme.sizes[4],
  },
  keywordContainer: {
    marginBottom: theme.sizes[3],
    textAlign: "center",
  },
  keyword: {
    marginTop: theme.sizes[1],
    marginRight: theme.sizes[3],
  },
  link: {
    paddingTop: 20,
    color: theme.palette.link.dark,
  },
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '12px',
  },
  statusContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: theme.spacing(2)
  },
  deleteContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  }
});
